"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsUrlValidator {
    constructor(urlOptions) {
        this.urlOptions = urlOptions;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isURL(input, this.urlOptions);
        }
        return false;
    }
}
exports.IsUrlValidator = IsUrlValidator;
//# sourceMappingURL=IsUrlValidator.js.map